import { AUTHSUCCESS,AUTHFAILED,AUTHRESET} from '../constants';
const INITIAL_STATE = {};
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case AUTHSUCCESS:
      return action.payload;
    case AUTHFAILED:
      return action.payload;
    case AUTHRESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
